import type { SVGProps } from 'react';

export type IconName = 'home' | 'materials' | 'ai' | 'courses' | 'profile' | 'history' | 'upload' | 'filter' | 'send' | 'close' | 'chevron' | 'image' | 'sparkles' | 'back' | 'check';

const paths: Record<IconName, React.ReactNode> = {
  home: <><path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z"/><path d="M9 21v-6h6v6"/></>,
  materials: <><path d="M4 15a7 7 0 0 0 12 4c4-.5 6-3 5-6-1-4-6-5-10-2-2 1-4 2-7 1"/><path d="M7 8c1-4 5-6 9-4 2 1 3 3 3 5"/></>,
  ai: <><path d="m4 20 11-11 4 4L8 24Z"/><path d="m13 11 4 4M6 4l.7 2.3L9 7l-2.3.7L6 10l-.7-2.3L3 7l2.3-.7ZM17 1l.5 1.5L19 3l-1.5.5L17 5l-.5-1.5L15 3l1.5-.5Z"/></>,
  courses: <><path d="M8 3h8l2 6-3 3v8H9v-8L6 9Z"/><path d="M9 8h6M10 16h4"/></>,
  profile: <><circle cx="12" cy="8" r="4"/><path d="M4 22c.5-5 3-8 8-8s7.5 3 8 8"/></>,
  history: <><path d="M4 5c4-2 7-1 8 1 1-2 4-3 8-1v15c-4-2-7-1-8 1-1-2-4-3-8-1Z"/><path d="M12 6v15M7 9h2M15 9h2"/></>,
  upload: <><path d="M12 17V4M7 9l5-5 5 5M4 18v3h16v-3"/></>,
  filter: <path d="M3 5h18l-7 8v6l-4 2v-8Z"/>,
  send: <><path d="m3 11 18-8-7 18-3-7Z"/><path d="m11 14 4-5"/></>,
  close: <path d="m5 5 14 14M19 5 5 19"/>,
  chevron: <path d="m9 5 7 7-7 7"/>,
  image: <><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m5 18 5-5 3 3 2-2 4 4"/></>,
  sparkles: <><path d="m12 2 1.2 3.8L17 7l-3.8 1.2L12 12l-1.2-3.8L7 7l3.8-1.2Z"/><path d="m5 13 .8 2.2L8 16l-2.2.8L5 19l-.8-2.2L2 16l2.2-.8Z"/></>,
  back: <path d="m15 4-8 8 8 8"/>,
  check: <path d="m5 12 4 4L19 6"/>
};

export function Icon({ name, size = 24, ...props }: SVGProps<SVGSVGElement> & { name: IconName; size?: number }) {
  return <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>{paths[name]}</svg>;
}
